export const newPlanDefaults = {
    title: "",
    description: "",
    elements: [],
    imageUrl: "",
    isActive: false,
    learningObjectives: [],
    start: null,
    stop: null,
    activeFromDT: null,
    topic: null,
    url: null,
    fields: []
};
